import { useMemo } from 'react';
import './descriptor.component.scss';
export const DescriptorsComponent = ({ metadata }: { metadata: any }) => {
  const descriptors: string[] | null = useMemo(() => {
    const list: string[] | null = metadata?.descriptors
      ? metadata.descriptors.concat()
      : null;
    if (list) {
      list.splice(list.length - 1, 1);
      return list.length > 0 ? list : null;
    }
    return list;
  }, [metadata]);

  if (descriptors === null) return null;

  return (
    <div className="descriptor-container">
      {descriptors.map((i: any, index) => (
        <div key={index} className="descriptor-item">
          {index === 0 ? '' : ' | '}
          {i}
        </div>
      ))}
    </div>
  );
};
